<div class="flex flex-col items-center gap-10 text-center px-4 py-12">
  <img [src]="image()" class="w-fit" alt="Fehler" />
  <div>
    <div class="font-grotesk-h5">{{ headline() }}</div>
    <div class="mt-6">{{ message() }}</div>
  </div>

  <div class="flex gap-4">
    @if (showBack()) {
      <button mat-flat-button class="btn-primary-lg" (click)="back.emit()">Zurück</button>
    }
    @if (showRetry()) {
      <button mat-flat-button class="btn-secondary-lg" (click)="retry.emit()">
        Erneut versuchen
      </button>
    }
  </div>
</div>
